export default "__VITE_ASSET__bb7b205b__"